import { createFileRoute } from '@tanstack/react-router'
import DashboardScreen from './-components/screen'
import { Loading } from '@/layouts/loading'
import { pharmacyClient } from '@/connect'
import dayjs from 'dayjs'

export const Route = createFileRoute('/(inventory)/branch/_layout/dashboard/')({
  component: DashboardScreen,
  loader: async () => {
    const stockPoinstInfo =  await pharmacyClient.getStockPoints({
      startDate: dayjs().startOf('month').unix(),
      endDate: dayjs().endOf('month').unix(),
    })
    const inventoryOverview = await pharmacyClient.inventoryOverview({})
    return {
      stockPoinstInfo: stockPoinstInfo,
      inventoryOverview: inventoryOverview
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
})
